import React, { useState } from "react";
import { Text } from "../../formitems/Index";
import {
  Client,
  Fleets,
  subcatagory,
  Publish_Ground_Form,
} from "../../../Queries/GroundFormQuery/GroundQuery";
import { useQuery, useMutation } from "@apollo/client";
import { Select, Switch, InputNumber } from "antd";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const GroundForm = () => {
  const [AddActive, setAddActive] = useState("");
  const [dropdown2, setdropdown2] = useState("");
  const [toggle, settoggle] = useState(false);
  const [value, setval] = useState("");
  const [dropdown, setdropdown] = useState("");
  const [dropdown4, setdropdown4] = useState("");
  const [richtexttoggle, setrichtexttoggle] = useState(false);
  const [toggle4, settoggle4] = useState(false);
  const [toggle5, settoggle5] = useState(false);
  const [name, setname] = useState("");
  const [minutes, setminutes] = useState(30);
  const [validity, setvalidity] = useState(30);
  const { data: client } = useQuery(Client);
  const [pubishGroundForm, data] = useMutation(Publish_Ground_Form);
  const { data: subCatagory } = useQuery(subcatagory);
  const { data: fleets } = useQuery(Fleets, {
    variables: { id: dropdown2[1] },
  });
  function onChange(value) {
    setvalidity(value);
  }
  const togle4 = () => {
    toggle4 ? settoggle4(false) : settoggle4(true);
  };
  const togle5 = () => {
    toggle5 ? settoggle5(false) : settoggle5(true);
  };
  const togle2 = () => {
    richtexttoggle ? setrichtexttoggle(false) : setrichtexttoggle(true);
  };
  function onChangee(value) {
    setminutes(value);
  }
  const handlerOnChange = (e, editor) => {
    const data = editor.getData();
    setval(data);
  };
  const Option = Select.Option;
  return (
    <div className="animate__animated animate__fadeIn">
      <div className="category-title">Ground Form</div>
      <div className={toggle || richtexttoggle ? "hide-element" : ""}>
        <div className="toggle-form-container">
          <label>Client</label>
          <Select
            defaultValue="Select Client"
            onChange={(e) => setdropdown2(e)}
          >
            {client?.aatmsv4_clients?.map((el, i) => (
              <Option key={i} value={[el.clientname, el.clientsid]}>
                {el.clientname}
              </Option>
            ))}
          </Select>
          <Text
            title="Enter unique qualification code in format(ClientNo) +(G)+(Code)"
            value={name}
            onChange={(e) => setname(e.target.value)}
            placeholder="(ClientNo) + (G) + (Code)"
          />
          <label>Fleet</label>
          <Select defaultValue="Select Fleet" onChange={(e) => setdropdown(e)}>
            {fleets?.aatmsv4_fleets?.map((el, i) => (
              <Option key={i} value={[el.aircraft, el.fleetsid]}>
                {el.aircraft}
              </Option>
            ))}
          </Select>
          <div>
            Course Duration in Minutes{" "}
            <span style={{ color: "burlywood" }}> (30 to 480)</span>
          </div>
          <InputNumber
            size="large"
            style={{ width: "300px" }}
            min={30}
            max={480}
            defaultValue={minutes}
            onChange={onChangee}
          />{" "}
          <br /> <br />
          <div>
            Validity <span style={{ color: "burlywood" }}>(30 to 9999)</span>
          </div>
          <InputNumber
            size="large"
            style={{ width: "300px" }}
            min={30}
            max={9999}
            defaultValue={validity}
            onChange={onChange}
          />{" "}
          <br /> <br />
          <Text title="Category" value="Ground" disabled />
          <Select
            defaultValue="Sub Catagories"
            onChange={(e) => setdropdown4(e)}
          >
            {subCatagory?.aatmsv4_subcategory?.map((el, i) => (
              <Option key={i} value={el.subcategoryid}>
                {el.subcategoryid}
              </Option>
            ))}
          </Select>
          <Text
            title="Name of the ground training"
            value={name}
            onChange={(e) => setname(e.target.value)}
          />
          <Text
            title="Renewal Procedure"
            value={name}
            onChange={(e) => setname(e.target.value)}
          />
          <div className={richtexttoggle ? "hide-element" : ""}>
            <button
              className="submit-button"
              onClick={() => {
                pubishGroundForm({
                  variables: {
                    validity: validity,
                    clientsid: dropdown2[1],
                    clientsname: dropdown2[0],
                    fleetsid: dropdown[1],
                    groundformname: name,
                    minutes: minutes,
                    regulatoryinfo: value,
                    remarks: toggle4,
                    result: toggle5,
                    subcategory: dropdown4,
                  },
                });
                setdropdown2("");
                setvalidity(30);
                setminutes(30);
                settoggle5(false);
                settoggle4(false);
                settoggle4(false);
                setdropdown("");
                setdropdown4("");
                setname("");
                setval("");
              }}
            >
              Publish Form
            </button>
            <button className="preview-button">
              <i className="fa fa-eye" />
              Preview
            </button>
            <button className="cancel-button">Cancel</button>
          </div>
          {name ? (
            <div>
              <div>Add Remarks Section</div>
              <Switch onClick={togle4} /> <br /> <br />
              <div>Add Result Section</div>
              <Switch onClick={togle5} />
              <br />
              <br />
              <div>Add Regulatory Information Section</div>
              <Switch onClick={togle2} />
            </div>
          ) : null}
        </div>
      </div>
      <div className={richtexttoggle ? "" : "hide-element"}>
        {richtexttoggle ? (
          <div style={{ height: "250px" }}>
            <CKEditor editor={ClassicEditor} onChange={handlerOnChange} />
            <button
              className="cancel-button"
              onClick={() => setrichtexttoggle(false)}
            >
              Done
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default GroundForm;
